import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step6 from './Step6-redux';

export default compose(
  withRouter,
  withNextStep
)(Step6);
